export const cleanPhone = (phone) => {
  return phone.replace(/[^0-9]/g, '').trim().replace('+', '')
}
